export default {
  data() {
    return {
      jobs: [
        {
          label: 'Livelog Test',
          name: 'livelog_test',
        },
        {
          label: 'Livelog Clear',
          name: 'livelog_clear',
        },
        {
          label: 'Fetch Latest',
          name: 'fetch_latest',
        },
        {
          label: 'Fetch Currently Tagged',
          name: 'fetch_tagged',
        },
        {
          label: 'Reset Tags',
          name: 'reset_tags',
        },
      ],
    };
  },
};
